import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import UnlockIcon from '@wix/da-ds/pkg/Icons/24x24/Unlock';
import { CommissionStatusCodes, CommissionStatusType } from '../../../types/commissions';
import CommissionConfirmation from '../../../CommissionEditPopup/CommissionConfirmation';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
export const CommissionStatusButton = ({ deviation, onClick })=>{
    const { t } = useTranslation();
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    if (!deviation.commission || deviation.commission.status === CommissionStatusCodes.STATUS_DELETED) {
        return null;
    }
    const isActive = deviation.commission.status === CommissionStatusCodes.STATUS_ACTIVE;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: isActive ? t('actionbar.closeCommission') : t('actionbar.openCommission')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: ()=>setShowConfirmationPopup(true)
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: isActive ? UnlockIcon : LockIcon
    }))), showConfirmationPopup && /*#__PURE__*/ React.createElement(CommissionConfirmation, {
        isOpen: true,
        confirmationType: isActive ? 'disable' : 'enable',
        onCancel: ()=>setShowConfirmationPopup(false),
        onConfirm: ()=>{
            setShowConfirmationPopup(false);
            onClick({
                deviation,
                status: isActive ? CommissionStatusType.DISABLED : CommissionStatusType.ACTIVE
            });
        }
    }));
};
CommissionStatusButton.displayName = 'CommissionStatusButton';
export default CommissionStatusButton;

//# sourceMappingURL=CommissionStatusButton.js.map